import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, useLocation } from "react-router-dom";

import "./index.css";
import "./fonts.css";
import "./animations.css";

import { GetParam } from "./pkg/query/getparam";
import { GetRequest } from "./pkg/request/get";
import { URL } from "./pkg/microcms/parameters";
import { Headers } from "./pkg/microcms/headers";

import Header from "./components/header/body";
import Content from "./components/content/body";
import Footer from "./components/footer/body";

const Page = () => {
  const [data, setData] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(true);
  const search = useLocation().search;
  let param = GetParam(search);
  
  React.useEffect(() => {
    GetRequest(param, setData, URL, Headers());
    // ローディング完了を少し遅らせてアニメーションを見やすくする
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2500); // お寺らしいローディングを楽しめるよう少し長めに

    return () => clearTimeout(timer);
  }, [param]);

  // SPA のページ遷移を GA4 に送信
  React.useEffect(() => {
    if (window.gtag) {
      window.gtag("event", "page_view", {
        page_path: window.location.pathname + search,
        page_title: data.title || document.title,
      });
    }
  }, [search, data.title]);

  if (isLoading) {
    return (
      <div className="temple-loading-screen">
        <div className="temple-bg-overlay"></div>
        <div className="temple-loading-content">
          <div className="temple-logo-container">
            <img src="logo.png" alt="玉泉院" className="temple-logo-loading" />
            <div className="temple-circle-animation"></div>
            <div className="temple-circle-animation delay-1"></div>
            <div className="temple-circle-animation delay-2"></div>
          </div>
        </div>
        <div className="temple-particles">
          <div className="particle"></div>
          <div className="particle"></div>
          <div className="particle"></div>
          <div className="particle"></div>
          <div className="particle"></div>
          <div className="particle"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="page-container fade-in">
      <Header title={data.title} />
      <Content __html={data.content} />
      <Footer />
    </div>
  );
};

ReactDOM.render(
  <BrowserRouter>
    <Page />
  </BrowserRouter>,
  document.getElementById("root")
);
